import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

/**
 * CLE-2659: the "Additional information" free-text area of CMS-R-131 (Exp. 03/31/2029) — a labelled
 * blank space bounded by rules, followed by the standard notice paragraph.
 *
 * The 2026 form keeps these as two distinct blocks; the previous revision of this document merged
 * them under a single "H. Additional Information:" heading.
 */
export function AdditionalInformation({ note }: { note?: string }) {
  return (
    <View style={{ display: "flex", flexDirection: "column", marginTop: 8 }}>
      <View style={{ borderTopWidth: 1, borderColor: "#000" }} />
      <Text
        style={{
          ...styles.bodyText,
          fontFamily: "Helvetica-Bold",
          fontSize: 10,
          marginTop: 3,
          marginBottom: 0,
        }}
      >
        Additional information:
      </Text>
      <Text style={{ ...styles.bodyText, fontSize: 10, minHeight: 22 }}>
        {note ?? ""}
      </Text>
      <View style={{ borderTopWidth: 1, borderColor: "#000" }} />
      <Text style={{ ...styles.bodyText, fontSize: 11, marginTop: 4 }}>
        This notice gives our opinion, not an official Medicare decision. For
        other questions about this notice or Medicare billing, call
        1-800-MEDICARE (1-800-633-4227). TTY users can call 1-877-486-2048.
        Signing below means you received and understand this notice. You can ask
        to get a copy.
      </Text>
    </View>
  );
}
